import { useFeatureValue } from '@growthbook/growthbook-react';
import useCartCheckoutV2 from './useCartCheckoutV2';

/**
 * Whether hardware-first checkout offers the 30-day free trial: enrollment, cart v2 and the
 * 'hardware-first-free-trial' feature. Off, hardware-first checkout hides and strips trial bundles as before.
 */
export default function useHardwareFirstFreeTrial(): boolean {
  const cartCheckoutV2 = useCartCheckoutV2();
  const trialFlag = useFeatureValue<boolean>('hardware-first-free-trial', false);
  return cartCheckoutV2 && trialFlag;
}
